import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { fetchInternationalPatientContacts } from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";
import { baseUrl } from "../../variables/Variables";

const ListInternationalContacts = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetchInternationalPatientContacts();
        setRows((response.data || []).sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        )
        );
      } catch (err) {
        toast.error("Failed to load contact data.");
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "full_name", headerName: "Full Name", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "customer_query", headerName: "Query", width: 300 },
    {
      field: "report",
      headerName: "Report",
      width: 200,
      renderCell: (params) =>
        params.row.report ? (
          <a href={`${baseUrl}${params.row.report}`} target="_blank" rel="noreferrer">
            View Report
          </a>
        ) : (
          "N/A"
        ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) => new Date(params.value).toLocaleString("en-IN"),
    },
  ];

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>International Contact List</Typography>
      {loading ? <CircularProgress /> : <DataGrid rows={rows} columns={columns} autoHeight getRowId={(row) => row.id} />}
    </Box>
  );
};

export default ListInternationalContacts;